import { dividerPrefixCls } from "@/base/components/divider/Divider.component";
import { THEME_PREFIX } from "@/base/constant";
import {
  genComponentStyleHook,
  type FullToken,
  type GenerateStyle,
} from "antd/es/theme/internal";

const genStyle: GenerateStyle<FullToken<"Divider">> = () => ({
  [`.${THEME_PREFIX}`]: {
    [`&.${dividerPrefixCls}`]: {},
  },
});

export const useDividerStyle = genComponentStyleHook(
  ["Divider", "cso"],
  (token) => {
    return [genStyle(token)];
  },
);
